import { API_PDC_URL_V2 } from "../../../config";
import { callWithRetry } from "../../services/callWithRetry";
import { createHttpHeaderWithAuthorization } from "../../services/http-header";

export const presetsConstants = {
  GET_BACKOFFICE_FULFILMENTS_START: "GET_BACKOFFICE_FULFILMENTS_START",
  GET_BACKOFFICE_FULFILMENTS_SUCCESS: "GET_BACKOFFICE_FULFILMENTS_SUCCESS",
  GET_BACKOFFICE_FULFILMENTS_ERROR: "GET_BACKOFFICE_FULFILMENTS_ERROR"
};

export function getBackofficeFulfilmentsOld(
  auth, managerId, itemId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: presetsConstants.GET_BACKOFFICE_FULFILMENTS_START
      });
      let request = {
        method: "GET",
        url: `${API_PDC_URL_V2}/fulfilments/backoffice/fulfilments`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: presetsConstants.GET_BACKOFFICE_FULFILMENTS_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: presetsConstants.GET_BACKOFFICE_FULFILMENTS_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}

export function getBackofficeFulfilments(
  auth, managerId, itemId
) {
  return (dispatch) => {
    return new Promise(function(resolve, reject) {
      dispatch({
        type: presetsConstants.GET_BACKOFFICE_FULFILMENTS_START
      });
      let request = {
        method: "GET",
        url: `${API_PDC_URL_V2}/fulfilments/raw?ownerId=${managerId}`,
        headers: {
          ...createHttpHeaderWithAuthorization(auth.loginAuth.securityToken)
        }
      };

      callWithRetry(
        auth, request, dispatch
      )
        .then((response) => {
          dispatch({
            type: presetsConstants.GET_BACKOFFICE_FULFILMENTS_SUCCESS,
            payload: response.data
          });
          resolve(response.data);
        })
        .catch((e) => {
          dispatch({
            type: presetsConstants.GET_BACKOFFICE_FULFILMENTS_ERROR,
            payload: { error: e }
          });
          reject(e);
        });
    });
  };
}
